const createEmployeeNumber = (set, get) => ({
  employeeNumber: localStorage.getItem('employeeNumber') || null,
  
  setEmployeeNumber: (employeeNumber: string | null) => {
    if (employeeNumber) {
      localStorage.setItem('employeeNumber', employeeNumber);
    } else {
      localStorage.removeItem('employeeNumber');
    }
    
    set((state) => ({
      ...state,
      employeeNumber,
    }));
  },
  
  handleNumber: (employeeNumber: string) => {
    const { setEmployeeNumber } = get();
    setEmployeeNumber(employeeNumber);
  },
  
  clearEmployeeNumber: () => {
    const { setEmployeeNumber } = get();
    setEmployeeNumber(null);
  },
});

export default createEmployeeNumber;